module.exports = __webpack_public_path__ + "img/LogoRusoft.9f2baacb.png";